import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import adapter from './adapter'
import service from './service'

const initialState = {
  status: 'idle',
  error: '',
  data: [],

  respond_status: 'idle',
  respond_error: '',
  respond_data: [],
}

export const fetchInvitations = createAsyncThunk('invitations/fetchInvitations', async (options) => {
  const data = await service.getData(options)
  return data
})

export const respond = createAsyncThunk('invitations/respond', async (options) => {
  const data = await service.respond(options)
  return data
})

export const inviationsSlice = createSlice({
  name: 'invitations',
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    }
  },
  extraReducers: {
    // Bulk
    [fetchInvitations.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchInvitations.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state._payload = action.payload

      state.data = action.payload
        .map(a => adapter.responseBodyToRender(a))
        // type 1 = invitation; organisasi mengundang seorang individu untuk bergabung.
        // type 2 = join request; seorang individu meminta untuk bergabung dengan organisasi.
        .filter(a => a.type === 1)
    },
    [fetchInvitations.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },

    [respond.pending]: (state) => {
      state.respond_status = 'loading'
    },
    [respond.fulfilled]: (state, action) => {
      state.respond_status = 'succeeded'
      state.respond_data = action.payload
    },
    [respond.rejected]: (state, action) => {
      state.respond_status = 'failed'
      state.respond_error = action.error.message
    },
  }
})

export const { setStatus } = inviationsSlice.actions

export default inviationsSlice.reducer
